import React, { Component } from 'react'

export default class LoginViewSlider extends Component {
    componentDidMount() {
        this.props.setColor(this.props.bg)
    }
    render() {
        return (
            <div className="w-100 h-100 flexcc window-content-radius" style={{ background: this.props.bg }}>
                <div className='bg-white br-20 p-3 m-4'>
                    <p className='font-size-16 main-c3 weight-600'>{this.props.title}</p>
                    <p className='font-size-12 main-c6'>{this.props.des}</p>
                </div>
            </div>
        )
    }
}
